import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { LocalesComponent } from '@shared/location/locales/locales.component';
import { TitleAndSubtitleComponent } from '@shared/title-and-subtitle/title-and-subtitle';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-location[title]',
    imports: [
        ContentWrapperComponent,
        NgOptimizedImage,
        AssetPipe,
        LocalesComponent,
        TitleAndSubtitleComponent,
        RouterLink,
    ],
    templateUrl: './location.component.html',
    styleUrl: './location.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationComponent {
    public title = input.required<string>();
    public subtitle = input<string>('');
}
